module.exports = __webpack_public_path__ + "static/NPS-92bddc2711fee87db7e2475d8c89ec58.png";